import { init as initConfig, setup as setupConfig } from '@cian/config/browser';
import { init as initLogger } from '@cian/logger/browser';
import { init as initTelemetry, setup as setupTelemetry } from '@cian/telemetry/browser';
import { init as initHttpApi, setup as setupHttpApi } from '@cian/http-api/browser';
import { init as initGlobalBehaviors } from '@cian/global-behaviors/browser';
import { init as initWeb } from '@cian/web/browser';
import { initWS } from './app/ws';
import 'url-search-params-polyfill';

setupConfig({ settingsKey: 'frontend-header' });
setupTelemetry();
initGlobalBehaviors();
setupHttpApi({});

export const config = initConfig();
export const logger = initLogger();
export const telemetryLogger = initTelemetry();
export const httpApi = initHttpApi();
initWeb();

initWS();
